import styled from 'styled-components';

export const UiCustomerFormPage = styled.div`
	display: block;
`;